module.exports = __webpack_public_path__ + "static/media/hung.31850b99.jpg";